(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DoseFormDialogController', DoseFormDialogController);

    DoseFormDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DoseForm'];

    function DoseFormDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DoseForm) {
        var vm = this;

        vm.doseForm = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.doseForm.id !== null) {
                DoseForm.update(vm.doseForm, onSaveSuccess, onSaveError);
            } else {
                DoseForm.save(vm.doseForm, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:doseFormUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
